import axios from 'axios';
import {
  TCreatePost,
  TPostDetail,
  TPostResponse,
  TUpsertPostLike,
} from 'types';

const getPost = async (postId: number): Promise<TPostDetail> => {
  const res = await axios.get(`post/${postId}`).then(function (response) {
    return response.data;
  });

  return res;
};

const getRecommendPostList = async (
  currentPage: number,
  pageSize: number,
): Promise<TPostResponse> => {
  const res = await axios
    .get('post', {
      params: {
        currentPage: currentPage,
        pageSize: pageSize,
      },
    })
    .then(function (response) {
      return response.data;
    });

  return res;
};

const getSalonPostList = async (
  currentPage: number,
  pageSize: number,
): Promise<TPostResponse> => {
  const res = await axios
    .get('post/salon', {
      params: {
        currentPage: currentPage,
        pageSize: pageSize,
      },
    })
    .then(function (response) {
      return response.data;
    });

  return res;
};

const getAdminPosterPosts = async (params: {
  adminPosterId: number;
  currentPage: number;
  pageSize: number;
}): Promise<TPostResponse> => {
  const res = await axios.get('post', { params }).then(function (response) {
    return response.data;
  });

  return res;
};

const getFemalePosts = async (params: {
  userId: number;
  currentPage: number;
  pageSize: number;
}): Promise<TPostResponse> => {
  const res = await axios.get('post', { params }).then(function (response) {
    return response.data;
  });

  return res;
};

const getPremiumPostList = async (
  currentPage: number,
  pageSize: number,
): Promise<TPostResponse> => {
  const res = await axios
    .get('post', {
      params: {
        currentPage,
        pageSize,
        isPremium: true,
      },
    })
    .then(function (response) {
      return response.data;
    });

  return res;
};

const createPost = async (body: TCreatePost): Promise<TPostResponse> => {
  const res = await axios.post('post', body).then(function (response) {
    return response.data;
  });

  return res;
};

const getPremiumPurchasedList = async (
  currentPage: number,
  pageSize: number,
): Promise<TPostResponse> => {
  const res = await axios
    .get('post/premium-purchased', {
      params: {
        currentPage,
        pageSize,
      },
    })
    .then(function (response) {
      return response.data;
    });

  return res;
};

const createPostLike = async (body: TUpsertPostLike): Promise<boolean> => {
  const res = await axios.post('post/like', body).then(function (response) {
    return response.data;
  });

  return res;
};

const deletePostLike = async (body: TUpsertPostLike): Promise<boolean> => {
  const res = await axios.patch('post/like', body).then(function (response) {
    return response.data;
  });

  return res;
};

export {
  getPost,
  getRecommendPostList,
  getSalonPostList,
  getAdminPosterPosts,
  getFemalePosts,
  getPremiumPurchasedList,
  getPremiumPostList,
  createPost,
  createPostLike,
  deletePostLike,
};
